import { render, staticRenderFns } from "./MinButton.vue?vue&type=template&id=10577a24&"
import script from "./MinButton.vue?vue&type=script&lang=js&"
export * from "./MinButton.vue?vue&type=script&lang=js&"
import style0 from "./MinButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/q7gCdwre/0/h5group/renpho-lex/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10577a24')) {
      api.createRecord('10577a24', component.options)
    } else {
      api.reload('10577a24', component.options)
    }
    module.hot.accept("./MinButton.vue?vue&type=template&id=10577a24&", function () {
      api.rerender('10577a24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MinButton.vue"
export default component.exports